import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { MessageError } from '@utils/errors';

export const usePostK01 = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await companyApis.post('/dashboard/company/{id}/k01/', {
        path: { id },
      });
      if (response[400]) {
        throw new MessageError(response[400].message);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/detail/`]);
      },
    },
  );
};
